import { TrayGroup } from '@modules/private/payment/components/payment-adjust-modal/payment-adjust-modal.component'

/** Lo mínimo para pintar un grupo como ficha: cómo se llama, con qué se dibuja y de qué tono es. */
export interface GrupoChip {
	key: TrayGroup
	label: string
	icon: string
	tono: 'danger' | 'warning' | 'muted'
	/** De dónde sale su importe en el `resumen` del endpoint. El conteo va por la propia clave. */
	montoKey: string
}

/**
 * Los tres grupos de «por atender», **en orden de urgencia**.
 *
 * Viven aquí y no dentro de la bandeja porque las fichas se pintan en la barra de Cobranza —arriba,
 * junto al segmentado— y la bandeja solo pinta el grupo elegido. La bandeja sigue siendo dueña de
 * las explicaciones largas de cada grupo; esto es solo su etiqueta.
 *
 * El orden no es alfabético ni el del backend: primero lo que tiene dinero parado, y anulados al
 * final porque son la bitácora de lo ya resuelto.
 *
 * Hubo un cuarto, «atorados», que se retiró junto con la operación de destrabar: ese estado no lo
 * produce ninguna ruta de la API. Un valor `?grupo=atorados` guardado en un marcador viejo cae en el
 * grupo por defecto, que es justo lo que hace `grupoValido`.
 */
export const GRUPOS_POR_ATENDER: GrupoChip[] = [
	{ key: 'remanentes', label: 'Con remanente', icon: 'fa-solid fa-coins', tono: 'warning', montoKey: 'montoRemanente' },
	{ key: 'posiblesDuplicados', label: 'Posibles duplicados', icon: 'fa-solid fa-clone', tono: 'warning', montoKey: 'montoPosibleDuplicado' },
	{ key: 'anulados', label: 'Anulados aquí', icon: 'fa-solid fa-ban', tono: 'muted', montoKey: 'montoAnulado' },
]

/** El grupo que abre por defecto: el que tiene dinero que no acaba de cerrar. */
export const GRUPO_POR_DEFECTO: TrayGroup = 'remanentes'

/** Traduce lo que venga en la dirección a un grupo real. Un valor inventado cae en el de siempre. */
export function grupoValido(valor: string | null | undefined): TrayGroup {
	return GRUPOS_POR_ATENDER.some((g) => g.key === valor) ? (valor as TrayGroup) : GRUPO_POR_DEFECTO
}
